package one.healthium.ricediet

import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseUrls
import one.primehealth.app.FirebaseAppConfig
import one.primehealth.app.Flavour
import one.primehealth.app.PlatformValues

fun appConfig(flavour: Flavour) =
    BaseAppConfig(
        baseUrls = BaseUrls(
            content = when (flavour) {
                Flavour.Stage -> "https://rice-content-stage.web.app/"
                Flavour.Prod -> "https://rice-content-prod.web.app/"
            }
        ),
        intercomApiKey = PlatformValues(
            android = "android_sdk-376cc4ff3418a1fc242d34ef12e9c3d4ff8b9fa8",
            ios = "ios_sdk-1f273098a984821e01c616b73804fe92584b24d9",
            web = "",
        ),
        intercomAppKey = "qpjbxd63",
        intercomAppName = "RICE",
        amplitudeKey = when (flavour) {
            Flavour.Stage -> ""
            Flavour.Prod -> ""
        },
        adaptyKey = "public_live_jjoAYNyI.1vEMW76nOzcNfsH2uH0t",
        appsflyerKey = "obcS6CH7xbbq3Kgqd3xXUH",
        appleAppId = "6744553524",
        feedbackEmail = "ricediet@healthium.one",
        firebaseApp = when (flavour) {
            Flavour.Stage -> FirebaseAppConfig(
                applicationId = "1:772474462533:android:1e83aa4be1f119bc2b1e2c",
                apiKey = "AIzaSyC8PaBqyL64e9IIussUp_Jc4n9gFx_xW20",
                projectId = "rice-diet-app-stage",
                storageBucket = "rice-diet-app-stage.firebasestorage.app",
                userStorageBucket = "gs://rice-diet-app-stage-users-data",
                authDomain = "rice-diet-app-stage.firebaseapp.com",
            )

            Flavour.Prod -> FirebaseAppConfig(
                applicationId = "1:14460837796:android:97f3bc6fe0cda48e28eb31",
                apiKey = "AIzaSyDrR167s9o50LMU81lcd80uSEeGjp8GaE4",
                projectId = "rice-diet-app-prod",
                storageBucket = "rice-diet-app-prod.firebasestorage.app",
                userStorageBucket = "gs://rice-diet-app-prod-users-data",
                authDomain = "rice-diet-app-prod.firebaseapp.com",
            )
        },
        appId = when (flavour) {
            Flavour.Stage -> "rice_stage"
            Flavour.Prod -> "rice"
        },
        oneLinkBaseUrl = "https://hltm-ricediet.onelink.me/4qmU/web",
    )

